import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import Image from "next/image";
import styles from "./constellation.module.css";
export var ConstellationSection = function(blok) {
    var body = blok.body, image = blok.image;
    var _alt;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.wrapper,
        children: [
            (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image.filename,
                    alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : undefined,
                    layout: "fill"
                })
            }) : null,
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            })
        ]
    });
};
export default ConstellationSection;
